import { observer } from 'mobx-react-lite';

import type { TemporaryChartRig } from '../../../presets/drilling-rigs-chart/entities';
import { useMovableElement } from '../../../shared/use-movable-element';
import type { Viewport } from '../../../shared/viewport/viewport';

import styles from './data-items.module.scss';

interface Props {
  item: TemporaryChartRig;
  verticalViewport: Viewport;
}

export const EditingTemporaryRigRow = observer(function EditingTemporaryRigRow({ item, verticalViewport }: Props) {
  const ref = useMovableElement({
    item,
    verticalViewport,
  });

  return <div ref={ref} className={styles.temporaryRigRow} />;
});
